import { useEffect } from 'react';

const SITE_NAME = 'Le Bontà del Vesuvio';
const BASE_URL = 'https://www.lebontadelvesuvio.it';

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const SeoHead = ({ title, description, keywords, canonical, pageSchema }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Pomodorino Napoletano, Prodotti del Vesuvio, Conserve Artigianali`;

    document.title = fullTitle;
    setMeta('meta[name="description"]', 'content', description || '');
    if (keywords) setMeta('meta[name="keywords"]', 'content', keywords);
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    if (description) setMeta('meta[property="og:description"]', 'content', description);
    if (canonical) setMeta('link[rel="canonical"]', 'href', `${BASE_URL}${canonical}`);

    if (pageSchema) {
      const existing = document.querySelector('script[data-page-schema]');
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-page-schema', '1');
      script.textContent = JSON.stringify(pageSchema);
      document.head.appendChild(script);
    }

    return () => {
      const el = document.querySelector('script[data-page-schema]');
      if (el) el.remove();
    };
  }, [title, description, keywords, canonical, pageSchema]);

  return null;
};
